// Auto-generato da scripts/gen_country_iso3_map.py (ISO 3166, tutti
// i 249 paesi ufficiali) + alias multi-lingua verificati su dati
// reali Frabemar (bsc_practices, 2026-07-02). Chiave: stringa
// normalizzata (accenti rimossi, uppercase, solo alfanumerico+spazi).
// Valore: codice ISO 3166-1 alpha-2 (es. GA, BJ, GN) — la dashboard
// mostra solo alpha-2 (Phase 3). NON modificare a mano: rigenerare
// con lo script.
export const COUNTRY_ISO2_MAP: Record<string, string> = {
  "ARUBA": "AW",
  "AFGHANISTAN": "AF",
  "ISLAMIC REPUBLIC OF AFGHANISTAN": "AF",
  "ANGOLA": "AO",
  "REPUBLIC OF ANGOLA": "AO",
  "ANGUILLA": "AI",
  "ALAND ISLANDS": "AX",
  "ALBANIA": "AL",
  "REPUBLIC OF ALBANIA": "AL",
  "ANDORRA": "AD",
  "PRINCIPALITY OF ANDORRA": "AD",
  "UNITED ARAB EMIRATES": "AE",
  "ARGENTINA": "AR",
  "ARGENTINE REPUBLIC": "AR",
  "ARMENIA": "AM",
  "REPUBLIC OF ARMENIA": "AM",
  "AMERICAN SAMOA": "AS",
  "ANTARCTICA": "AQ",
  "FRENCH SOUTHERN TERRITORIES": "TF",
  "ANTIGUA AND BARBUDA": "AG",
  "AUSTRALIA": "AU",
  "AUSTRIA": "AT",
  "REPUBLIC OF AUSTRIA": "AT",
  "AZERBAIJAN": "AZ",
  "REPUBLIC OF AZERBAIJAN": "AZ",
  "BURUNDI": "BI",
  "REPUBLIC OF BURUNDI": "BI",
  "BELGIUM": "BE",
  "KINGDOM OF BELGIUM": "BE",
  "BENIN": "BJ",
  "REPUBLIC OF BENIN": "BJ",
  "BONAIRE SINT EUSTATIUS AND SABA": "BQ",
  "BURKINA FASO": "BF",
  "BANGLADESH": "BD",
  "PEOPLE S REPUBLIC OF BANGLADESH": "BD",
  "BULGARIA": "BG",
  "REPUBLIC OF BULGARIA": "BG",
  "BAHRAIN": "BH",
  "KINGDOM OF BAHRAIN": "BH",
  "BAHAMAS": "BS",
  "COMMONWEALTH OF THE BAHAMAS": "BS",
  "BOSNIA AND HERZEGOVINA": "BA",
  "REPUBLIC OF BOSNIA AND HERZEGOVINA": "BA",
  "SAINT BARTHELEMY": "BL",
  "BELARUS": "BY",
  "REPUBLIC OF BELARUS": "BY",
  "BELIZE": "BZ",
  "BERMUDA": "BM",
  "BOLIVIA PLURINATIONAL STATE OF": "BO",
  "PLURINATIONAL STATE OF BOLIVIA": "BO",
  "BOLIVIA": "BO",
  "BRAZIL": "BR",
  "FEDERATIVE REPUBLIC OF BRAZIL": "BR",
  "BARBADOS": "BB",
  "BRUNEI DARUSSALAM": "BN",
  "BHUTAN": "BT",
  "KINGDOM OF BHUTAN": "BT",
  "BOUVET ISLAND": "BV",
  "BOTSWANA": "BW",
  "REPUBLIC OF BOTSWANA": "BW",
  "CENTRAL AFRICAN REPUBLIC": "CF",
  "CANADA": "CA",
  "COCOS KEELING ISLANDS": "CC",
  "SWITZERLAND": "CH",
  "SWISS CONFEDERATION": "CH",
  "CHILE": "CL",
  "REPUBLIC OF CHILE": "CL",
  "CHINA": "CN",
  "PEOPLE S REPUBLIC OF CHINA": "CN",
  "COTE D IVOIRE": "CI",
  "REPUBLIC OF COTE D IVOIRE": "CI",
  "CAMEROON": "CM",
  "REPUBLIC OF CAMEROON": "CM",
  "CONGO THE DEMOCRATIC REPUBLIC OF THE": "CD",
  "CONGO": "CG",
  "REPUBLIC OF THE CONGO": "CG",
  "CONGO REPUBLIC OF": "CG",
  "CONGO REPUBLIC OF THE": "CG",
  "COOK ISLANDS": "CK",
  "COLOMBIA": "CO",
  "REPUBLIC OF COLOMBIA": "CO",
  "COMOROS": "KM",
  "UNION OF THE COMOROS": "KM",
  "CABO VERDE": "CV",
  "REPUBLIC OF CABO VERDE": "CV",
  "COSTA RICA": "CR",
  "REPUBLIC OF COSTA RICA": "CR",
  "CUBA": "CU",
  "REPUBLIC OF CUBA": "CU",
  "CURACAO": "CW",
  "CHRISTMAS ISLAND": "CX",
  "CAYMAN ISLANDS": "KY",
  "CYPRUS": "CY",
  "REPUBLIC OF CYPRUS": "CY",
  "CZECHIA": "CZ",
  "CZECH REPUBLIC": "CZ",
  "GERMANY": "DE",
  "FEDERAL REPUBLIC OF GERMANY": "DE",
  "DJIBOUTI": "DJ",
  "REPUBLIC OF DJIBOUTI": "DJ",
  "DOMINICA": "DM",
  "COMMONWEALTH OF DOMINICA": "DM",
  "DENMARK": "DK",
  "KINGDOM OF DENMARK": "DK",
  "DOMINICAN REPUBLIC": "DO",
  "ALGERIA": "DZ",
  "PEOPLE S DEMOCRATIC REPUBLIC OF ALGERIA": "DZ",
  "ECUADOR": "EC",
  "REPUBLIC OF ECUADOR": "EC",
  "EGYPT": "EG",
  "ARAB REPUBLIC OF EGYPT": "EG",
  "ERITREA": "ER",
  "THE STATE OF ERITREA": "ER",
  "WESTERN SAHARA": "EH",
  "SPAIN": "ES",
  "KINGDOM OF SPAIN": "ES",
  "ESTONIA": "EE",
  "REPUBLIC OF ESTONIA": "EE",
  "ETHIOPIA": "ET",
  "FEDERAL DEMOCRATIC REPUBLIC OF ETHIOPIA": "ET",
  "FINLAND": "FI",
  "REPUBLIC OF FINLAND": "FI",
  "FIJI": "FJ",
  "REPUBLIC OF FIJI": "FJ",
  "FALKLAND ISLANDS MALVINAS": "FK",
  "FRANCE": "FR",
  "FRENCH REPUBLIC": "FR",
  "FAROE ISLANDS": "FO",
  "MICRONESIA FEDERATED STATES OF": "FM",
  "FEDERATED STATES OF MICRONESIA": "FM",
  "GABON": "GA",
  "GABONESE REPUBLIC": "GA",
  "UNITED KINGDOM": "GB",
  "UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND": "GB",
  "GEORGIA": "GE",
  "GUERNSEY": "GG",
  "GHANA": "GH",
  "REPUBLIC OF GHANA": "GH",
  "GIBRALTAR": "GI",
  "GUINEA": "GN",
  "REPUBLIC OF GUINEA": "GN",
  "GUINEA REP": "GN",
  "GUINEA REPUBLIC": "GN",
  "CONGO DEMOCRATIC REPUBLIC": "CD",
  "COSTA D AVORIO": "CI",
  "GUADELOUPE": "GP",
  "GAMBIA": "GM",
  "REPUBLIC OF THE GAMBIA": "GM",
  "GUINEA BISSAU": "GW",
  "REPUBLIC OF GUINEA BISSAU": "GW",
  "EQUATORIAL GUINEA": "GQ",
  "REPUBLIC OF EQUATORIAL GUINEA": "GQ",
  "GREECE": "GR",
  "HELLENIC REPUBLIC": "GR",
  "GRENADA": "GD",
  "GREENLAND": "GL",
  "GUATEMALA": "GT",
  "REPUBLIC OF GUATEMALA": "GT",
  "FRENCH GUIANA": "GF",
  "GUAM": "GU",
  "GUYANA": "GY",
  "REPUBLIC OF GUYANA": "GY",
  "HONG KONG": "HK",
  "HONG KONG SPECIAL ADMINISTRATIVE REGION OF CHINA": "HK",
  "HEARD ISLAND AND MCDONALD ISLANDS": "HM",
  "HONDURAS": "HN",
  "REPUBLIC OF HONDURAS": "HN",
  "CROATIA": "HR",
  "REPUBLIC OF CROATIA": "HR",
  "HAITI": "HT",
  "REPUBLIC OF HAITI": "HT",
  "HUNGARY": "HU",
  "INDONESIA": "ID",
  "REPUBLIC OF INDONESIA": "ID",
  "ISLE OF MAN": "IM",
  "INDIA": "IN",
  "REPUBLIC OF INDIA": "IN",
  "BRITISH INDIAN OCEAN TERRITORY": "IO",
  "IRELAND": "IE",
  "IRAN ISLAMIC REPUBLIC OF": "IR",
  "ISLAMIC REPUBLIC OF IRAN": "IR",
  "IRAN": "IR",
  "IRAQ": "IQ",
  "REPUBLIC OF IRAQ": "IQ",
  "ICELAND": "IS",
  "REPUBLIC OF ICELAND": "IS",
  "ISRAEL": "IL",
  "STATE OF ISRAEL": "IL",
  "ITALY": "IT",
  "ITALIAN REPUBLIC": "IT",
  "JAMAICA": "JM",
  "JERSEY": "JE",
  "JORDAN": "JO",
  "HASHEMITE KINGDOM OF JORDAN": "JO",
  "JAPAN": "JP",
  "KAZAKHSTAN": "KZ",
  "REPUBLIC OF KAZAKHSTAN": "KZ",
  "KENYA": "KE",
  "REPUBLIC OF KENYA": "KE",
  "KYRGYZSTAN": "KG",
  "KYRGYZ REPUBLIC": "KG",
  "CAMBODIA": "KH",
  "KINGDOM OF CAMBODIA": "KH",
  "KIRIBATI": "KI",
  "REPUBLIC OF KIRIBATI": "KI",
  "SAINT KITTS AND NEVIS": "KN",
  "KOREA REPUBLIC OF": "KR",
  "SOUTH KOREA": "KR",
  "KUWAIT": "KW",
  "STATE OF KUWAIT": "KW",
  "LAO PEOPLE S DEMOCRATIC REPUBLIC": "LA",
  "LAOS": "LA",
  "LEBANON": "LB",
  "LEBANESE REPUBLIC": "LB",
  "LIBERIA": "LR",
  "REPUBLIC OF LIBERIA": "LR",
  "LIBYA": "LY",
  "SAINT LUCIA": "LC",
  "LIECHTENSTEIN": "LI",
  "PRINCIPALITY OF LIECHTENSTEIN": "LI",
  "SRI LANKA": "LK",
  "DEMOCRATIC SOCIALIST REPUBLIC OF SRI LANKA": "LK",
  "LESOTHO": "LS",
  "KINGDOM OF LESOTHO": "LS",
  "LITHUANIA": "LT",
  "REPUBLIC OF LITHUANIA": "LT",
  "LUXEMBOURG": "LU",
  "GRAND DUCHY OF LUXEMBOURG": "LU",
  "LATVIA": "LV",
  "REPUBLIC OF LATVIA": "LV",
  "MACAO": "MO",
  "MACAO SPECIAL ADMINISTRATIVE REGION OF CHINA": "MO",
  "SAINT MARTIN FRENCH PART": "MF",
  "MOROCCO": "MA",
  "KINGDOM OF MOROCCO": "MA",
  "MONACO": "MC",
  "PRINCIPALITY OF MONACO": "MC",
  "MOLDOVA REPUBLIC OF": "MD",
  "REPUBLIC OF MOLDOVA": "MD",
  "MOLDOVA": "MD",
  "MADAGASCAR": "MG",
  "REPUBLIC OF MADAGASCAR": "MG",
  "MALDIVES": "MV",
  "REPUBLIC OF MALDIVES": "MV",
  "MEXICO": "MX",
  "UNITED MEXICAN STATES": "MX",
  "MARSHALL ISLANDS": "MH",
  "REPUBLIC OF THE MARSHALL ISLANDS": "MH",
  "NORTH MACEDONIA": "MK",
  "REPUBLIC OF NORTH MACEDONIA": "MK",
  "MALI": "ML",
  "REPUBLIC OF MALI": "ML",
  "MALTA": "MT",
  "REPUBLIC OF MALTA": "MT",
  "MYANMAR": "MM",
  "REPUBLIC OF MYANMAR": "MM",
  "MONTENEGRO": "ME",
  "MONGOLIA": "MN",
  "NORTHERN MARIANA ISLANDS": "MP",
  "COMMONWEALTH OF THE NORTHERN MARIANA ISLANDS": "MP",
  "MOZAMBIQUE": "MZ",
  "REPUBLIC OF MOZAMBIQUE": "MZ",
  "MAURITANIA": "MR",
  "ISLAMIC REPUBLIC OF MAURITANIA": "MR",
  "MONTSERRAT": "MS",
  "MARTINIQUE": "MQ",
  "MAURITIUS": "MU",
  "REPUBLIC OF MAURITIUS": "MU",
  "MALAWI": "MW",
  "REPUBLIC OF MALAWI": "MW",
  "MALAYSIA": "MY",
  "MAYOTTE": "YT",
  "NAMIBIA": "NA",
  "REPUBLIC OF NAMIBIA": "NA",
  "NEW CALEDONIA": "NC",
  "NIGER": "NE",
  "REPUBLIC OF THE NIGER": "NE",
  "NORFOLK ISLAND": "NF",
  "NIGERIA": "NG",
  "FEDERAL REPUBLIC OF NIGERIA": "NG",
  "NICARAGUA": "NI",
  "REPUBLIC OF NICARAGUA": "NI",
  "NIUE": "NU",
  "NETHERLANDS": "NL",
  "KINGDOM OF THE NETHERLANDS": "NL",
  "NORWAY": "NO",
  "KINGDOM OF NORWAY": "NO",
  "NEPAL": "NP",
  "FEDERAL DEMOCRATIC REPUBLIC OF NEPAL": "NP",
  "NAURU": "NR",
  "REPUBLIC OF NAURU": "NR",
  "NEW ZEALAND": "NZ",
  "OMAN": "OM",
  "SULTANATE OF OMAN": "OM",
  "PAKISTAN": "PK",
  "ISLAMIC REPUBLIC OF PAKISTAN": "PK",
  "PANAMA": "PA",
  "REPUBLIC OF PANAMA": "PA",
  "PITCAIRN": "PN",
  "PERU": "PE",
  "REPUBLIC OF PERU": "PE",
  "PHILIPPINES": "PH",
  "REPUBLIC OF THE PHILIPPINES": "PH",
  "PALAU": "PW",
  "REPUBLIC OF PALAU": "PW",
  "PAPUA NEW GUINEA": "PG",
  "INDEPENDENT STATE OF PAPUA NEW GUINEA": "PG",
  "POLAND": "PL",
  "REPUBLIC OF POLAND": "PL",
  "PUERTO RICO": "PR",
  "KOREA DEMOCRATIC PEOPLE S REPUBLIC OF": "KP",
  "DEMOCRATIC PEOPLE S REPUBLIC OF KOREA": "KP",
  "NORTH KOREA": "KP",
  "PORTUGAL": "PT",
  "PORTUGUESE REPUBLIC": "PT",
  "PARAGUAY": "PY",
  "REPUBLIC OF PARAGUAY": "PY",
  "PALESTINE STATE OF": "PS",
  "THE STATE OF PALESTINE": "PS",
  "FRENCH POLYNESIA": "PF",
  "QATAR": "QA",
  "STATE OF QATAR": "QA",
  "REUNION": "RE",
  "ROMANIA": "RO",
  "RUSSIAN FEDERATION": "RU",
  "RWANDA": "RW",
  "RWANDESE REPUBLIC": "RW",
  "SAUDI ARABIA": "SA",
  "KINGDOM OF SAUDI ARABIA": "SA",
  "SUDAN": "SD",
  "REPUBLIC OF THE SUDAN": "SD",
  "SENEGAL": "SN",
  "REPUBLIC OF SENEGAL": "SN",
  "SINGAPORE": "SG",
  "REPUBLIC OF SINGAPORE": "SG",
  "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS": "GS",
  "SAINT HELENA ASCENSION AND TRISTAN DA CUNHA": "SH",
  "SVALBARD AND JAN MAYEN": "SJ",
  "SOLOMON ISLANDS": "SB",
  "SIERRA LEONE": "SL",
  "REPUBLIC OF SIERRA LEONE": "SL",
  "EL SALVADOR": "SV",
  "REPUBLIC OF EL SALVADOR": "SV",
  "SAN MARINO": "SM",
  "REPUBLIC OF SAN MARINO": "SM",
  "SOMALIA": "SO",
  "FEDERAL REPUBLIC OF SOMALIA": "SO",
  "SAINT PIERRE AND MIQUELON": "PM",
  "SERBIA": "RS",
  "REPUBLIC OF SERBIA": "RS",
  "SOUTH SUDAN": "SS",
  "REPUBLIC OF SOUTH SUDAN": "SS",
  "SAO TOME AND PRINCIPE": "ST",
  "DEMOCRATIC REPUBLIC OF SAO TOME AND PRINCIPE": "ST",
  "SURINAME": "SR",
  "REPUBLIC OF SURINAME": "SR",
  "SLOVAKIA": "SK",
  "SLOVAK REPUBLIC": "SK",
  "SLOVENIA": "SI",
  "REPUBLIC OF SLOVENIA": "SI",
  "SWEDEN": "SE",
  "KINGDOM OF SWEDEN": "SE",
  "ESWATINI": "SZ",
  "KINGDOM OF ESWATINI": "SZ",
  "SINT MAARTEN DUTCH PART": "SX",
  "SEYCHELLES": "SC",
  "REPUBLIC OF SEYCHELLES": "SC",
  "SYRIAN ARAB REPUBLIC": "SY",
  "SYRIA": "SY",
  "TURKS AND CAICOS ISLANDS": "TC",
  "CHAD": "TD",
  "REPUBLIC OF CHAD": "TD",
  "TOGO": "TG",
  "TOGOLESE REPUBLIC": "TG",
  "THAILAND": "TH",
  "KINGDOM OF THAILAND": "TH",
  "TAJIKISTAN": "TJ",
  "REPUBLIC OF TAJIKISTAN": "TJ",
  "TOKELAU": "TK",
  "TURKMENISTAN": "TM",
  "TIMOR LESTE": "TL",
  "DEMOCRATIC REPUBLIC OF TIMOR LESTE": "TL",
  "TONGA": "TO",
  "KINGDOM OF TONGA": "TO",
  "TRINIDAD AND TOBAGO": "TT",
  "REPUBLIC OF TRINIDAD AND TOBAGO": "TT",
  "TUNISIA": "TN",
  "REPUBLIC OF TUNISIA": "TN",
  "TURKIYE": "TR",
  "REPUBLIC OF TURKIYE": "TR",
  "TUVALU": "TV",
  "TAIWAN PROVINCE OF CHINA": "TW",
  "TAIWAN": "TW",
  "TANZANIA UNITED REPUBLIC OF": "TZ",
  "UNITED REPUBLIC OF TANZANIA": "TZ",
  "TANZANIA": "TZ",
  "UGANDA": "UG",
  "REPUBLIC OF UGANDA": "UG",
  "UKRAINE": "UA",
  "UNITED STATES MINOR OUTLYING ISLANDS": "UM",
  "URUGUAY": "UY",
  "EASTERN REPUBLIC OF URUGUAY": "UY",
  "UNITED STATES": "US",
  "UNITED STATES OF AMERICA": "US",
  "UZBEKISTAN": "UZ",
  "REPUBLIC OF UZBEKISTAN": "UZ",
  "HOLY SEE VATICAN CITY STATE": "VA",
  "SAINT VINCENT AND THE GRENADINES": "VC",
  "VENEZUELA BOLIVARIAN REPUBLIC OF": "VE",
  "BOLIVARIAN REPUBLIC OF VENEZUELA": "VE",
  "VENEZUELA": "VE",
  "VIRGIN ISLANDS BRITISH": "VG",
  "BRITISH VIRGIN ISLANDS": "VG",
  "VIRGIN ISLANDS U S": "VI",
  "VIRGIN ISLANDS OF THE UNITED STATES": "VI",
  "VIET NAM": "VN",
  "SOCIALIST REPUBLIC OF VIET NAM": "VN",
  "VIETNAM": "VN",
  "VANUATU": "VU",
  "REPUBLIC OF VANUATU": "VU",
  "WALLIS AND FUTUNA": "WF",
  "SAMOA": "WS",
  "INDEPENDENT STATE OF SAMOA": "WS",
  "YEMEN": "YE",
  "REPUBLIC OF YEMEN": "YE",
  "SOUTH AFRICA": "ZA",
  "REPUBLIC OF SOUTH AFRICA": "ZA",
  "ZAMBIA": "ZM",
  "REPUBLIC OF ZAMBIA": "ZM",
  "ZIMBABWE": "ZW",
  "REPUBLIC OF ZIMBABWE": "ZW",
  "AW": "AW",
  "ABW": "AW",
  "AF": "AF",
  "AFG": "AF",
  "AO": "AO",
  "AGO": "AO",
  "AI": "AI",
  "AIA": "AI",
  "AX": "AX",
  "ALA": "AX",
  "AL": "AL",
  "ALB": "AL",
  "AD": "AD",
  "AND": "AD",
  "AE": "AE",
  "ARE": "AE",
  "AR": "AR",
  "ARG": "AR",
  "AM": "AM",
  "ARM": "AM",
  "AS": "AS",
  "ASM": "AS",
  "AQ": "AQ",
  "ATA": "AQ",
  "TF": "TF",
  "ATF": "TF",
  "AG": "AG",
  "ATG": "AG",
  "AU": "AU",
  "AUS": "AU",
  "AT": "AT",
  "AUT": "AT",
  "AZ": "AZ",
  "AZE": "AZ",
  "BI": "BI",
  "BDI": "BI",
  "BE": "BE",
  "BEL": "BE",
  "BJ": "BJ",
  "BEN": "BJ",
  "BQ": "BQ",
  "BES": "BQ",
  "BF": "BF",
  "BFA": "BF",
  "BD": "BD",
  "BGD": "BD",
  "BG": "BG",
  "BGR": "BG",
  "BH": "BH",
  "BHR": "BH",
  "BS": "BS",
  "BHS": "BS",
  "BA": "BA",
  "BIH": "BA",
  "BL": "BL",
  "BLM": "BL",
  "BY": "BY",
  "BLR": "BY",
  "BZ": "BZ",
  "BLZ": "BZ",
  "BM": "BM",
  "BMU": "BM",
  "BO": "BO",
  "BOL": "BO",
  "BR": "BR",
  "BRA": "BR",
  "BB": "BB",
  "BRB": "BB",
  "BN": "BN",
  "BRN": "BN",
  "BT": "BT",
  "BTN": "BT",
  "BV": "BV",
  "BVT": "BV",
  "BW": "BW",
  "BWA": "BW",
  "CF": "CF",
  "CAF": "CF",
  "CA": "CA",
  "CAN": "CA",
  "CC": "CC",
  "CCK": "CC",
  "CH": "CH",
  "CHE": "CH",
  "CL": "CL",
  "CHL": "CL",
  "CN": "CN",
  "CHN": "CN",
  "CI": "CI",
  "CIV": "CI",
  "CM": "CM",
  "CMR": "CM",
  "CD": "CD",
  "COD": "CD",
  "CG": "CG",
  "COG": "CG",
  "CK": "CK",
  "COK": "CK",
  "CO": "CO",
  "COL": "CO",
  "KM": "KM",
  "COM": "KM",
  "CV": "CV",
  "CPV": "CV",
  "CR": "CR",
  "CRI": "CR",
  "CU": "CU",
  "CUB": "CU",
  "CW": "CW",
  "CUW": "CW",
  "CX": "CX",
  "CXR": "CX",
  "KY": "KY",
  "CYM": "KY",
  "CY": "CY",
  "CYP": "CY",
  "CZ": "CZ",
  "CZE": "CZ",
  "DE": "DE",
  "DEU": "DE",
  "DJ": "DJ",
  "DJI": "DJ",
  "DM": "DM",
  "DMA": "DM",
  "DK": "DK",
  "DNK": "DK",
  "DO": "DO",
  "DOM": "DO",
  "DZ": "DZ",
  "DZA": "DZ",
  "EC": "EC",
  "ECU": "EC",
  "EG": "EG",
  "EGY": "EG",
  "ER": "ER",
  "ERI": "ER",
  "EH": "EH",
  "ESH": "EH",
  "ES": "ES",
  "ESP": "ES",
  "EE": "EE",
  "EST": "EE",
  "ET": "ET",
  "ETH": "ET",
  "FI": "FI",
  "FIN": "FI",
  "FJ": "FJ",
  "FJI": "FJ",
  "FK": "FK",
  "FLK": "FK",
  "FR": "FR",
  "FRA": "FR",
  "FO": "FO",
  "FRO": "FO",
  "FM": "FM",
  "FSM": "FM",
  "GA": "GA",
  "GAB": "GA",
  "GB": "GB",
  "GBR": "GB",
  "GE": "GE",
  "GEO": "GE",
  "GG": "GG",
  "GGY": "GG",
  "GH": "GH",
  "GHA": "GH",
  "GI": "GI",
  "GIB": "GI",
  "GN": "GN",
  "GIN": "GN",
  "GP": "GP",
  "GLP": "GP",
  "GM": "GM",
  "GMB": "GM",
  "GW": "GW",
  "GNB": "GW",
  "GQ": "GQ",
  "GNQ": "GQ",
  "GR": "GR",
  "GRC": "GR",
  "GD": "GD",
  "GRD": "GD",
  "GL": "GL",
  "GRL": "GL",
  "GT": "GT",
  "GTM": "GT",
  "GF": "GF",
  "GUF": "GF",
  "GU": "GU",
  "GUM": "GU",
  "GY": "GY",
  "GUY": "GY",
  "HK": "HK",
  "HKG": "HK",
  "HM": "HM",
  "HMD": "HM",
  "HN": "HN",
  "HND": "HN",
  "HR": "HR",
  "HRV": "HR",
  "HT": "HT",
  "HTI": "HT",
  "HU": "HU",
  "HUN": "HU",
  "ID": "ID",
  "IDN": "ID",
  "IM": "IM",
  "IMN": "IM",
  "IN": "IN",
  "IND": "IN",
  "IO": "IO",
  "IOT": "IO",
  "IE": "IE",
  "IRL": "IE",
  "IR": "IR",
  "IRN": "IR",
  "IQ": "IQ",
  "IRQ": "IQ",
  "IS": "IS",
  "ISL": "IS",
  "IL": "IL",
  "ISR": "IL",
  "IT": "IT",
  "ITA": "IT",
  "JM": "JM",
  "JAM": "JM",
  "JE": "JE",
  "JEY": "JE",
  "JO": "JO",
  "JOR": "JO",
  "JP": "JP",
  "JPN": "JP",
  "KZ": "KZ",
  "KAZ": "KZ",
  "KE": "KE",
  "KEN": "KE",
  "KG": "KG",
  "KGZ": "KG",
  "KH": "KH",
  "KHM": "KH",
  "KI": "KI",
  "KIR": "KI",
  "KN": "KN",
  "KNA": "KN",
  "KR": "KR",
  "KOR": "KR",
  "KW": "KW",
  "KWT": "KW",
  "LA": "LA",
  "LAO": "LA",
  "LB": "LB",
  "LBN": "LB",
  "LR": "LR",
  "LBR": "LR",
  "LY": "LY",
  "LBY": "LY",
  "LC": "LC",
  "LCA": "LC",
  "LI": "LI",
  "LIE": "LI",
  "LK": "LK",
  "LKA": "LK",
  "LS": "LS",
  "LSO": "LS",
  "LT": "LT",
  "LTU": "LT",
  "LU": "LU",
  "LUX": "LU",
  "LV": "LV",
  "LVA": "LV",
  "MO": "MO",
  "MAC": "MO",
  "MF": "MF",
  "MAF": "MF",
  "MA": "MA",
  "MAR": "MA",
  "MC": "MC",
  "MCO": "MC",
  "MD": "MD",
  "MDA": "MD",
  "MG": "MG",
  "MDG": "MG",
  "MV": "MV",
  "MDV": "MV",
  "MX": "MX",
  "MEX": "MX",
  "MH": "MH",
  "MHL": "MH",
  "MK": "MK",
  "MKD": "MK",
  "ML": "ML",
  "MLI": "ML",
  "MT": "MT",
  "MLT": "MT",
  "MM": "MM",
  "MMR": "MM",
  "ME": "ME",
  "MNE": "ME",
  "MN": "MN",
  "MNG": "MN",
  "MP": "MP",
  "MNP": "MP",
  "MZ": "MZ",
  "MOZ": "MZ",
  "MR": "MR",
  "MRT": "MR",
  "MS": "MS",
  "MSR": "MS",
  "MQ": "MQ",
  "MTQ": "MQ",
  "MU": "MU",
  "MUS": "MU",
  "MW": "MW",
  "MWI": "MW",
  "MY": "MY",
  "MYS": "MY",
  "YT": "YT",
  "MYT": "YT",
  "NA": "NA",
  "NAM": "NA",
  "NC": "NC",
  "NCL": "NC",
  "NE": "NE",
  "NER": "NE",
  "NF": "NF",
  "NFK": "NF",
  "NG": "NG",
  "NGA": "NG",
  "NI": "NI",
  "NIC": "NI",
  "NU": "NU",
  "NIU": "NU",
  "NL": "NL",
  "NLD": "NL",
  "NO": "NO",
  "NOR": "NO",
  "NP": "NP",
  "NPL": "NP",
  "NR": "NR",
  "NRU": "NR",
  "NZ": "NZ",
  "NZL": "NZ",
  "OM": "OM",
  "OMN": "OM",
  "PK": "PK",
  "PAK": "PK",
  "PA": "PA",
  "PAN": "PA",
  "PN": "PN",
  "PCN": "PN",
  "PE": "PE",
  "PER": "PE",
  "PH": "PH",
  "PHL": "PH",
  "PW": "PW",
  "PLW": "PW",
  "PG": "PG",
  "PNG": "PG",
  "PL": "PL",
  "POL": "PL",
  "PR": "PR",
  "PRI": "PR",
  "KP": "KP",
  "PRK": "KP",
  "PT": "PT",
  "PRT": "PT",
  "PY": "PY",
  "PRY": "PY",
  "PS": "PS",
  "PSE": "PS",
  "PF": "PF",
  "PYF": "PF",
  "QA": "QA",
  "QAT": "QA",
  "RE": "RE",
  "REU": "RE",
  "RO": "RO",
  "ROU": "RO",
  "RU": "RU",
  "RUS": "RU",
  "RW": "RW",
  "RWA": "RW",
  "SA": "SA",
  "SAU": "SA",
  "SD": "SD",
  "SDN": "SD",
  "SN": "SN",
  "SEN": "SN",
  "SG": "SG",
  "SGP": "SG",
  "GS": "GS",
  "SGS": "GS",
  "SH": "SH",
  "SHN": "SH",
  "SJ": "SJ",
  "SJM": "SJ",
  "SB": "SB",
  "SLB": "SB",
  "SL": "SL",
  "SLE": "SL",
  "SV": "SV",
  "SLV": "SV",
  "SM": "SM",
  "SMR": "SM",
  "SO": "SO",
  "SOM": "SO",
  "PM": "PM",
  "SPM": "PM",
  "RS": "RS",
  "SRB": "RS",
  "SS": "SS",
  "SSD": "SS",
  "ST": "ST",
  "STP": "ST",
  "SR": "SR",
  "SUR": "SR",
  "SK": "SK",
  "SVK": "SK",
  "SI": "SI",
  "SVN": "SI",
  "SE": "SE",
  "SWE": "SE",
  "SZ": "SZ",
  "SWZ": "SZ",
  "SX": "SX",
  "SXM": "SX",
  "SC": "SC",
  "SYC": "SC",
  "SY": "SY",
  "SYR": "SY",
  "TC": "TC",
  "TCA": "TC",
  "TD": "TD",
  "TCD": "TD",
  "TG": "TG",
  "TGO": "TG",
  "TH": "TH",
  "THA": "TH",
  "TJ": "TJ",
  "TJK": "TJ",
  "TK": "TK",
  "TKL": "TK",
  "TM": "TM",
  "TKM": "TM",
  "TL": "TL",
  "TLS": "TL",
  "TO": "TO",
  "TON": "TO",
  "TT": "TT",
  "TTO": "TT",
  "TN": "TN",
  "TUN": "TN",
  "TR": "TR",
  "TUR": "TR",
  "TV": "TV",
  "TUV": "TV",
  "TW": "TW",
  "TWN": "TW",
  "TZ": "TZ",
  "TZA": "TZ",
  "UG": "UG",
  "UGA": "UG",
  "UA": "UA",
  "UKR": "UA",
  "UM": "UM",
  "UMI": "UM",
  "UY": "UY",
  "URY": "UY",
  "US": "US",
  "USA": "US",
  "UZ": "UZ",
  "UZB": "UZ",
  "VA": "VA",
  "VAT": "VA",
  "VC": "VC",
  "VCT": "VC",
  "VE": "VE",
  "VEN": "VE",
  "VG": "VG",
  "VGB": "VG",
  "VI": "VI",
  "VIR": "VI",
  "VN": "VN",
  "VNM": "VN",
  "VU": "VU",
  "VUT": "VU",
  "WF": "WF",
  "WLF": "WF",
  "WS": "WS",
  "WSM": "WS",
  "YE": "YE",
  "YEM": "YE",
  "ZA": "ZA",
  "ZAF": "ZA",
  "ZM": "ZM",
  "ZMB": "ZM",
  "ZW": "ZW",
  "ZWE": "ZW",
  "ANDORRE": "AD",
  "EMIRATS ARABES UNIS": "AE",
  "ANTIGUA ET BARBUDA": "AG",
  "ALBANIE": "AL",
  "ARMENIE": "AM",
  "ANTARCTIQUE": "AQ",
  "ARGENTINE": "AR",
  "SAMOA AMERICAINES": "AS",
  "AUTRICHE": "AT",
  "AUSTRALIE": "AU",
  "ILES ALAND": "AX",
  "AZERBAIDJAN": "AZ",
  "BOSNIE HERZEGOVINE": "BA",
  "BARBADE": "BB",
  "BELGIQUE": "BE",
  "BULGARIE": "BG",
  "BAHREIN": "BH",
  "BERMUDES": "BM",
  "BRUNEI": "BN",
  "BOLIVIE": "BO",
  "PAYS BAS CARIBEENS": "BQ",
  "BRESIL": "BR",
  "BHOUTAN": "BT",
  "ILE BOUVET": "BV",
  "BIELORUSSIE": "BY",
  "ILES COCOS": "CC",
  "CONGO KINSHASA": "CD",
  "REPUBLIQUE CENTRAFRICAINE": "CF",
  "CONGO BRAZZAVILLE": "CG",
  "SUISSE": "CH",
  "COTE DIVOIRE": "CI",
  "ILES COOK": "CK",
  "CHILI": "CL",
  "CAMEROUN": "CM",
  "CHINE": "CN",
  "COLOMBIE": "CO",
  "CAP VERT": "CV",
  "ILE CHRISTMAS": "CX",
  "CHYPRE": "CY",
  "TCHEQUIE": "CZ",
  "ALLEMAGNE": "DE",
  "DANEMARK": "DK",
  "DOMINIQUE": "DM",
  "REPUBLIQUE DOMINICAINE": "DO",
  "ALGERIE": "DZ",
  "EQUATEUR": "EC",
  "ESTONIE": "EE",
  "EGYPTE": "EG",
  "SAHARA OCCIDENTAL": "EH",
  "ERYTHREE": "ER",
  "ESPAGNE": "ES",
  "ETHIOPIE": "ET",
  "FINLANDE": "FI",
  "FIDJI": "FJ",
  "ILES MALOUINES": "FK",
  "MICRONESIE": "FM",
  "ILES FEROE": "FO",
  "ROYAUME UNI": "GB",
  "GRENADE": "GD",
  "GEORGIE": "GE",
  "GUYANE FRANCAISE": "GF",
  "GUERNESEY": "GG",
  "GROENLAND": "GL",
  "GAMBIE": "GM",
  "GUINEE": "GN",
  "GUINEE EQUATORIALE": "GQ",
  "GRECE": "GR",
  "GEORGIE DU SUD ET LES ILES SANDWICH DU SUD": "GS",
  "GUINEE BISSAU": "GW",
  "R A S CHINOISE DE HONG KONG": "HK",
  "ILES HEARD ET MACDONALD": "HM",
  "CROATIE": "HR",
  "HONGRIE": "HU",
  "INDONESIE": "ID",
  "IRLANDE": "IE",
  "ILE DE MAN": "IM",
  "INDE": "IN",
  "TERRITOIRE BRITANNIQUE DE LOCEAN INDIEN": "IO",
  "IRAK": "IQ",
  "ISLANDE": "IS",
  "ITALIE": "IT",
  "JAMAIQUE": "JM",
  "JORDANIE": "JO",
  "JAPON": "JP",
  "KIRGHIZSTAN": "KG",
  "CAMBODGE": "KH",
  "COMORES": "KM",
  "SAINT CHRISTOPHE ET NIEVES": "KN",
  "COREE DU NORD": "KP",
  "COREE DU SUD": "KR",
  "KOWEIT": "KW",
  "ILES CAIMANS": "KY",
  "LIBAN": "LB",
  "SAINTE LUCIE": "LC",
  "LITUANIE": "LT",
  "LETTONIE": "LV",
  "LIBYE": "LY",
  "MAROC": "MA",
  "MOLDAVIE": "MD",
  "SAINT MARTIN": "MF",
  "ILES MARSHALL": "MH",
  "MACEDOINE DU NORD": "MK",
  "MYANMAR BIRMANIE": "MM",
  "MONGOLIE": "MN",
  "R A S CHINOISE DE MACAO": "MO",
  "ILES MARIANNES DU NORD": "MP",
  "MAURITANIE": "MR",
  "MALTE": "MT",
  "MAURICE": "MU",
  "MEXIQUE": "MX",
  "MALAISIE": "MY",
  "NAMIBIE": "NA",
  "NOUVELLE CALEDONIE": "NC",
  "ILE NORFOLK": "NF",
  "PAYS BAS": "NL",
  "NORVEGE": "NO",
  "NOUVELLE ZELANDE": "NZ",
  "PEROU": "PE",
  "POLYNESIE FRANCAISE": "PF",
  "PAPOUASIE NOUVELLE GUINEE": "PG",
  "POLOGNE": "PL",
  "SAINT PIERRE ET MIQUELON": "PM",
  "ILES PITCAIRN": "PN",
  "PORTO RICO": "PR",
  "TERRITOIRES PALESTINIENS": "PS",
  "PALAOS": "PW",
  "LA REUNION": "RE",
  "ROUMANIE": "RO",
  "SERBIE": "RS",
  "RUSSIE": "RU",
  "ARABIE SAOUDITE": "SA",
  "ILES SALOMON": "SB",
  "SOUDAN": "SD",
  "SUEDE": "SE",
  "SINGAPOUR": "SG",
  "SAINTE HELENE": "SH",
  "SLOVENIE": "SI",
  "SVALBARD ET JAN MAYEN": "SJ",
  "SLOVAQUIE": "SK",
  "SAINT MARIN": "SM",
  "SOMALIE": "SO",
  "SOUDAN DU SUD": "SS",
  "SAO TOME ET PRINCIPE": "ST",
  "SALVADOR": "SV",
  "SAINT MARTIN PARTIE NEERLANDAISE": "SX",
  "SYRIE": "SY",
  "ILES TURQUES ET CAIQUES": "TC",
  "TCHAD": "TD",
  "TERRES AUSTRALES FRANCAISES": "TF",
  "THAILANDE": "TH",
  "TADJIKISTAN": "TJ",
  "TIMOR ORIENTAL": "TL",
  "TUNISIE": "TN",
  "TURQUIE": "TR",
  "TRINITE ET TOBAGO": "TT",
  "TANZANIE": "TZ",
  "OUGANDA": "UG",
  "ILES MINEURES ELOIGNEES DES ETATS UNIS": "UM",
  "ETATS UNIS": "US",
  "OUZBEKISTAN": "UZ",
  "ETAT DE LA CITE DU VATICAN": "VA",
  "SAINT VINCENT ET LES GRENADINES": "VC",
  "ILES VIERGES BRITANNIQUES": "VG",
  "ILES VIERGES DES ETATS UNIS": "VI",
  "WALLIS ET FUTUNA": "WF",
  "AFRIQUE DU SUD": "ZA",
  "ZAMBIE": "ZM",
  "EMIRATI ARABI UNITI": "AE",
  "ANTIGUA E BARBUDA": "AG",
  "ANTARTIDE": "AQ",
  "SAMOA AMERICANE": "AS",
  "ISOLE ALAND": "AX",
  "AZERBAIGIAN": "AZ",
  "BOSNIA ED ERZEGOVINA": "BA",
  "BELGIO": "BE",
  "CARAIBI OLANDESI": "BQ",
  "BRASILE": "BR",
  "ISOLA BOUVET": "BV",
  "BIELORUSSIA": "BY",
  "ISOLE COCOS KEELING": "CC",
  "REPUBBLICA CENTRAFRICANA": "CF",
  "SVIZZERA": "CH",
  "COSTA DAVORIO": "CI",
  "ISOLE COOK": "CK",
  "CILE": "CL",
  "CAMERUN": "CM",
  "CINA": "CN",
  "CAPO VERDE": "CV",
  "ISOLA CHRISTMAS": "CX",
  "CIPRO": "CY",
  "CECHIA": "CZ",
  "GERMANIA": "DE",
  "GIBUTI": "DJ",
  "DANIMARCA": "DK",
  "REPUBBLICA DOMINICANA": "DO",
  "EGITTO": "EG",
  "SAHARA OCCIDENTALE": "EH",
  "SPAGNA": "ES",
  "ETIOPIA": "ET",
  "FINLANDIA": "FI",
  "FIGI": "FJ",
  "ISOLE FALKLAND": "FK",
  "MICRONESIA": "FM",
  "ISOLE FR ER": "FO",
  "FRANCIA": "FR",
  "REGNO UNITO": "GB",
  "GUYANA FRANCESE": "GF",
  "GIBILTERRA": "GI",
  "GROENLANDIA": "GL",
  "GUADALUPA": "GP",
  "GUINEA EQUATORIALE": "GQ",
  "GRECIA": "GR",
  "GEORGIA DEL SUD E SANDWICH AUSTRALI": "GS",
  "RAS DI HONG KONG": "HK",
  "ISOLE HEARD E MCDONALD": "HM",
  "CROAZIA": "HR",
  "UNGHERIA": "HU",
  "IRLANDA": "IE",
  "ISRAELE": "IL",
  "ISOLA DI MAN": "IM",
  "TERRITORIO BRITANNICO DELLOCEANO INDIANO": "IO",
  "ISLANDA": "IS",
  "ITALIA": "IT",
  "GIAMAICA": "JM",
  "GIORDANIA": "JO",
  "GIAPPONE": "JP",
  "KIRGHIZISTAN": "KG",
  "CAMBOGIA": "KH",
  "COMORE": "KM",
  "SAINT KITTS E NEVIS": "KN",
  "COREA DEL NORD": "KP",
  "COREA DEL SUD": "KR",
  "ISOLE CAYMAN": "KY",
  "KAZAKISTAN": "KZ",
  "LIBANO": "LB",
  "LITUANIA": "LT",
  "LUSSEMBURGO": "LU",
  "LETTONIA": "LV",
  "LIBIA": "LY",
  "MAROCCO": "MA",
  "MOLDAVIA": "MD",
  "ISOLE MARSHALL": "MH",
  "MACEDONIA DEL NORD": "MK",
  "MYANMAR BIRMANIA": "MM",
  "RAS DI MACAO": "MO",
  "ISOLE MARIANNE SETTENTRIONALI": "MP",
  "MARTINICA": "MQ",
  "MALDIVE": "MV",
  "MESSICO": "MX",
  "MOZAMBICO": "MZ",
  "NUOVA CALEDONIA": "NC",
  "ISOLA NORFOLK": "NF",
  "PAESI BASSI": "NL",
  "NORVEGIA": "NO",
  "NUOVA ZELANDA": "NZ",
  "POLINESIA FRANCESE": "PF",
  "PAPUA NUOVA GUINEA": "PG",
  "FILIPPINE": "PH",
  "POLONIA": "PL",
  "SAINT PIERRE E MIQUELON": "PM",
  "ISOLE PITCAIRN": "PN",
  "PORTORICO": "PR",
  "TERRITORI PALESTINESI": "PS",
  "PORTOGALLO": "PT",
  "RIUNIONE": "RE",
  "RUSSIA": "RU",
  "RUANDA": "RW",
  "ARABIA SAUDITA": "SA",
  "ISOLE SALOMONE": "SB",
  "SVEZIA": "SE",
  "SANTELENA": "SH",
  "SVALBARD E JAN MAYEN": "SJ",
  "SLOVACCHIA": "SK",
  "SUD SUDAN": "SS",
  "SAO TOME E PRINCIPE": "ST",
  "SINT MAARTEN": "SX",
  "SIRIA": "SY",
  "ISOLE TURKS E CAICOS": "TC",
  "CIAD": "TD",
  "TERRE AUSTRALI FRANCESI": "TF",
  "THAILANDIA": "TH",
  "TAGIKISTAN": "TJ",
  "TIMOR EST": "TL",
  "TURCHIA": "TR",
  "TRINIDAD E TOBAGO": "TT",
  "UCRAINA": "UA",
  "ISOLE MINORI ESTERNE DEGLI STATI UNITI": "UM",
  "STATI UNITI": "US",
  "CITTA DEL VATICANO": "VA",
  "SAINT VINCENT E GRENADINE": "VC",
  "ISOLE VERGINI BRITANNICHE": "VG",
  "ISOLE VERGINI AMERICANE": "VI",
  "WALLIS E FUTUNA": "WF",
  "SUDAFRICA": "ZA",
  "EMIRATOS ARABES UNIDOS": "AE",
  "AFGANISTAN": "AF",
  "ANTIGUA Y BARBUDA": "AG",
  "ANGUILA": "AI",
  "ANTARTIDA": "AQ",
  "SAMOA AMERICANA": "AS",
  "ISLAS ALAND": "AX",
  "AZERBAIYAN": "AZ",
  "BOSNIA Y HERZEGOVINA": "BA",
  "BANGLADES": "BD",
  "BELGICA": "BE",
  "BAREIN": "BH",
  "SAN BARTOLOME": "BL",
  "BERMUDAS": "BM",
  "CARIBE NEERLANDES": "BQ",
  "BRASIL": "BR",
  "BUTAN": "BT",
  "ISLA BOUVET": "BV",
  "BOTSUANA": "BW",
  "BIELORRUSIA": "BY",
  "BELICE": "BZ",
  "ISLAS COCOS": "CC",
  "REPUBLICA DEMOCRATICA DEL CONGO": "CD",
  "REPUBLICA CENTROAFRICANA": "CF",
  "SUIZA": "CH",
  "ISLAS COOK": "CK",
  "CURAZAO": "CW",
  "ISLA DE NAVIDAD": "CX",
  "CHIPRE": "CY",
  "CHEQUIA": "CZ",
  "ALEMANIA": "DE",
  "YIBUTI": "DJ",
  "DINAMARCA": "DK",
  "REPUBLICA DOMINICANA": "DO",
  "ARGELIA": "DZ",
  "EGIPTO": "EG",
  "ESPANA": "ES",
  "FIYI": "FJ",
  "ISLAS MALVINAS": "FK",
  "ISLAS FEROE": "FO",
  "REINO UNIDO": "GB",
  "GRANADA": "GD",
  "GUAYANA FRANCESA": "GF",
  "GUADALUPE": "GP",
  "GUINEA ECUATORIAL": "GQ",
  "ISLAS GEORGIA DEL SUR Y SANDWICH DEL SUR": "GS",
  "GUINEA BISAU": "GW",
  "RAE DE HONG KONG CHINA": "HK",
  "ISLAS HEARD Y MCDONALD": "HM",
  "CROACIA": "HR",
  "HUNGRIA": "HU",
  "ISLA DE MAN": "IM",
  "TERRITORIO BRITANICO DEL OCEANO INDICO": "IO",
  "ISLANDIA": "IS",
  "JORDANIA": "JO",
  "KENIA": "KE",
  "KIRGUISTAN": "KG",
  "CAMBOYA": "KH",
  "COMORAS": "KM",
  "SAN CRISTOBAL Y NIEVES": "KN",
  "COREA DEL NORTE": "KP",
  "COREA DEL SUR": "KR",
  "ISLAS CAIMAN": "KY",
  "KAZAJISTAN": "KZ",
  "SANTA LUCIA": "LC",
  "LESOTO": "LS",
  "LUXEMBURGO": "LU",
  "LETONIA": "LV",
  "MARRUECOS": "MA",
  "SAN MARTIN": "MF",
  "ISLAS MARSHALL": "MH",
  "MACEDONIA DEL NORTE": "MK",
  "RAE DE MACAO CHINA": "MO",
  "ISLAS MARIANAS DEL NORTE": "MP",
  "MAURICIO": "MU",
  "MALDIVAS": "MV",
  "MALAUI": "MW",
  "MALASIA": "MY",
  "NUEVA CALEDONIA": "NC",
  "ISLA NORFOLK": "NF",
  "PAISES BAJOS": "NL",
  "NORUEGA": "NO",
  "NUEVA ZELANDA": "NZ",
  "POLINESIA FRANCESA": "PF",
  "PAPUA NUEVA GUINEA": "PG",
  "FILIPINAS": "PH",
  "SAN PEDRO Y MIQUELON": "PM",
  "ISLAS PITCAIRN": "PN",
  "TERRITORIOS PALESTINOS": "PS",
  "CATAR": "QA",
  "RUMANIA": "RO",
  "RUSIA": "RU",
  "ARABIA SAUDI": "SA",
  "ISLAS SALOMON": "SB",
  "SUECIA": "SE",
  "SINGAPUR": "SG",
  "SANTA ELENA": "SH",
  "ESLOVENIA": "SI",
  "SVALBARD Y JAN MAYEN": "SJ",
  "ESLOVAQUIA": "SK",
  "SIERRA LEONA": "SL",
  "SURINAM": "SR",
  "SUDAN DEL SUR": "SS",
  "SANTO TOME Y PRINCIPE": "ST",
  "ESUATINI": "SZ",
  "ISLAS TURCAS Y CAICOS": "TC",
  "TERRITORIOS AUSTRALES FRANCESES": "TF",
  "TAILANDIA": "TH",
  "TAYIKISTAN": "TJ",
  "TUNEZ": "TN",
  "TURQUIA": "TR",
  "TRINIDAD Y TOBAGO": "TT",
  "UCRANIA": "UA",
  "ISLAS MENORES ALEJADAS DE EE UU": "UM",
  "ESTADOS UNIDOS": "US",
  "CIUDAD DEL VATICANO": "VA",
  "SAN VICENTE Y LAS GRANADINAS": "VC",
  "ISLAS VIRGENES BRITANICAS": "VG",
  "ISLAS VIRGENES DE EE UU": "VI",
  "WALLIS Y FUTUNA": "WF",
  "ZIMBABUE": "ZW",
  "VEREINIGTE ARABISCHE EMIRATE": "AE",
  "ANTIGUA UND BARBUDA": "AG",
  "ALBANIEN": "AL",
  "ARMENIEN": "AM",
  "ANTARKTIS": "AQ",
  "ARGENTINIEN": "AR",
  "AMERIKANISCH SAMOA": "AS",
  "OSTERREICH": "AT",
  "AUSTRALIEN": "AU",
  "ALANDINSELN": "AX",
  "ASERBAIDSCHAN": "AZ",
  "BOSNIEN UND HERZEGOWINA": "BA",
  "BANGLADESCH": "BD",
  "BELGIEN": "BE",
  "BULGARIEN": "BG",
  "ST BARTHELEMY": "BL",
  "BOLIVIEN": "BO",
  "KARIBISCHE NIEDERLANDE": "BQ",
  "BRASILIEN": "BR",
  "BOUVETINSEL": "BV",
  "KANADA": "CA",
  "KOKOSINSELN": "CC",
  "KONGO KINSHASA": "CD",
  "ZENTRALAFRIKANISCHE REPUBLIK": "CF",
  "KONGO BRAZZAVILLE": "CG",
  "SCHWEIZ": "CH",
  "COOKINSELN": "CK",
  "KAMERUN": "CM",
  "KOLUMBIEN": "CO",
  "KUBA": "CU",
  "WEIHNACHTSINSEL": "CX",
  "ZYPERN": "CY",
  "TSCHECHIEN": "CZ",
  "DEUTSCHLAND": "DE",
  "DSCHIBUTI": "DJ",
  "DOMINIKANISCHE REPUBLIK": "DO",
  "ALGERIEN": "DZ",
  "ESTLAND": "EE",
  "AGYPTEN": "EG",
  "WESTSAHARA": "EH",
  "SPANIEN": "ES",
  "ATHIOPIEN": "ET",
  "FINNLAND": "FI",
  "FIDSCHI": "FJ",
  "FALKLANDINSELN": "FK",
  "MIKRONESIEN": "FM",
  "FAROER": "FO",
  "FRANKREICH": "FR",
  "GABUN": "GA",
  "VEREINIGTES KONIGREICH": "GB",
  "GEORGIEN": "GE",
  "FRANZOSISCH GUAYANA": "GF",
  "GRONLAND": "GL",
  "AQUATORIALGUINEA": "GQ",
  "GRIECHENLAND": "GR",
  "SUDGEORGIEN UND DIE SUDLICHEN SANDWICHINSELN": "GS",
  "SONDERVERWALTUNGSREGION HONGKONG": "HK",
  "HEARD UND MCDONALDINSELN": "HM",
  "KROATIEN": "HR",
  "UNGARN": "HU",
  "INDONESIEN": "ID",
  "IRLAND": "IE",
  "INDIEN": "IN",
  "BRITISCHES TERRITORIUM IM INDISCHEN OZEAN": "IO",
  "ISLAND": "IS",
  "ITALIEN": "IT",
  "JAMAIKA": "JM",
  "JORDANIEN": "JO",
  "KIRGISISTAN": "KG",
  "KAMBODSCHA": "KH",
  "KOMOREN": "KM",
  "ST KITTS UND NEVIS": "KN",
  "NORDKOREA": "KP",
  "SUDKOREA": "KR",
  "KAIMANINSELN": "KY",
  "KASACHSTAN": "KZ",
  "LIBANON": "LB",
  "ST LUCIA": "LC",
  "LITAUEN": "LT",
  "LUXEMBURG": "LU",
  "LETTLAND": "LV",
  "LIBYEN": "LY",
  "MAROKKO": "MA",
  "REPUBLIK MOLDAU": "MD",
  "ST MARTIN": "MF",
  "MADAGASKAR": "MG",
  "MARSHALLINSELN": "MH",
  "NORDMAZEDONIEN": "MK",
  "MONGOLEI": "MN",
  "SONDERVERWALTUNGSREGION MACAU": "MO",
  "NORDLICHE MARIANEN": "MP",
  "MAURETANIEN": "MR",
  "MALEDIVEN": "MV",
  "MEXIKO": "MX",
  "MOSAMBIK": "MZ",
  "NEUKALEDONIEN": "NC",
  "NORFOLKINSEL": "NF",
  "NIEDERLANDE": "NL",
  "NORWEGEN": "NO",
  "NEUSEELAND": "NZ",
  "FRANZOSISCH POLYNESIEN": "PF",
  "PAPUA NEUGUINEA": "PG",
  "PHILIPPINEN": "PH",
  "POLEN": "PL",
  "ST PIERRE UND MIQUELON": "PM",
  "PITCAIRNINSELN": "PN",
  "PALASTINENSISCHE AUTONOMIEGEBIETE": "PS",
  "KATAR": "QA",
  "RUMANIEN": "RO",
  "SERBIEN": "RS",
  "RUSSLAND": "RU",
  "SAUDI ARABIEN": "SA",
  "SALOMONEN": "SB",
  "SEYCHELLEN": "SC",
  "SCHWEDEN": "SE",
  "ST HELENA": "SH",
  "SLOWENIEN": "SI",
  "SPITZBERGEN UND JAN MAYEN": "SJ",
  "SLOWAKEI": "SK",
  "SUDSUDAN": "SS",
  "SAO TOME UND PRINCIPE": "ST",
  "SYRIEN": "SY",
  "TURKS UND CAICOSINSELN": "TC",
  "TSCHAD": "TD",
  "FRANZOSISCHE SUD UND ANTARKTISGEBIETE": "TF",
  "TADSCHIKISTAN": "TJ",
  "TUNESIEN": "TN",
  "TURKEI": "TR",
  "TRINIDAD UND TOBAGO": "TT",
  "TANSANIA": "TZ",
  "AMERIKANISCHE UBERSEEINSELN": "UM",
  "VEREINIGTE STAATEN": "US",
  "USBEKISTAN": "UZ",
  "VATIKANSTADT": "VA",
  "ST VINCENT UND DIE GRENADINEN": "VC",
  "BRITISCHE JUNGFERNINSELN": "VG",
  "AMERIKANISCHE JUNGFERNINSELN": "VI",
  "WALLIS UND FUTUNA": "WF",
  "JEMEN": "YE",
  "SUDAFRIKA": "ZA",
  "SAMBIA": "ZM",
  "SIMBABWE": "ZW",
  "EMIRADOS ARABES UNIDOS": "AE",
  "AFEGANISTAO": "AF",
  "ILHAS ALAND": "AX",
  "AZERBAIJAO": "AZ",
  "BOSNIA E HERZEGOVINA": "BA",
  "BURQUINA FASO": "BF",
  "SAO BARTOLOMEU": "BL",
  "PAISES BAIXOS CARIBENHOS": "BQ",
  "BUTAO": "BT",
  "ILHA BOUVET": "BV",
  "BIELORRUSSIA": "BY",
  "ILHAS COCOS KEELING": "CC",
  "REPUBLICA CENTRO AFRICANA": "CF",
  "REPUBLICA DO CONGO": "CG",
  "SUICA": "CH",
  "COSTA DO MARFIM": "CI",
  "ILHAS COOK": "CK",
  "CAMAROES": "CM",
  "ILHA CHRISTMAS": "CX",
  "TCHEQUIA": "CZ",
  "ALEMANHA": "DE",
  "DJIBUTI": "DJ",
  "EQUADOR": "EC",
  "EGITO": "EG",
  "SAARA OCIDENTAL": "EH",
  "ERITREIA": "ER",
  "ESPANHA": "ES",
  "ILHAS MALVINAS": "FK",
  "ILHAS FAROE": "FO",
  "FRANCA": "FR",
  "GABAO": "GA",
  "GUIANA FRANCESA": "GF",
  "GANA": "GH",
  "GUINE": "GN",
  "GUINE EQUATORIAL": "GQ",
  "ILHAS GEORGIA DO SUL E SANDWICH DO SUL": "GS",
  "GUINE BISSAU": "GW",
  "GUIANA": "GY",
  "HONG KONG RAE DA CHINA": "HK",
  "ILHAS HEARD E MCDONALD": "HM",
  "ILHA DE MAN": "IM",
  "TERRITORIO BRITANICO DO OCEANO INDICO": "IO",
  "IRAQUE": "IQ",
  "IRA": "IR",
  "JAPAO": "JP",
  "QUENIA": "KE",
  "QUIRGUISTAO": "KG",
  "CAMBOJA": "KH",
  "QUIRIBATI": "KI",
  "SAO CRISTOVAO E NEVIS": "KN",
  "COREIA DO NORTE": "KP",
  "COREIA DO SUL": "KR",
  "ILHAS CAYMAN": "KY",
  "CAZAQUISTAO": "KZ",
  "MARROCOS": "MA",
  "SAO MARTINHO": "MF",
  "ILHAS MARSHALL": "MH",
  "MACEDONIA DO NORTE": "MK",
  "MIANMAR BIRMANIA": "MM",
  "MACAU RAE DA CHINA": "MO",
  "ILHAS MARIANAS DO NORTE": "MP",
  "MOCAMBIQUE": "MZ",
  "NOVA CALEDONIA": "NC",
  "ILHA NORFOLK": "NF",
  "PAISES BAIXOS": "NL",
  "NOVA ZELANDIA": "NZ",
  "OMA": "OM",
  "PAPUA NOVA GUINE": "PG",
  "PAQUISTAO": "PK",
  "SAO PEDRO E MIQUELAO": "PM",
  "ILHAS PITCAIRN": "PN",
  "PARAGUAI": "PY",
  "REUNIAO": "RE",
  "ROMENIA": "RO",
  "SERVIA": "RS",
  "ILHAS SALOMAO": "SB",
  "SEICHELES": "SC",
  "SUDAO": "SD",
  "SINGAPURA": "SG",
  "SANTA HELENA": "SH",
  "SERRA LEOA": "SL",
  "SUDAO DO SUL": "SS",
  "ESSUATINI": "SZ",
  "ILHAS TURCAS E CAICOS": "TC",
  "CHADE": "TD",
  "TERRITORIOS FRANCESES DO SUL": "TF",
  "TADJIQUISTAO": "TJ",
  "TURCOMENISTAO": "TM",
  "ILHAS MENORES DISTANTES DOS EUA": "UM",
  "URUGUAI": "UY",
  "UZBEQUISTAO": "UZ",
  "CIDADE DO VATICANO": "VA",
  "SAO VICENTE E GRANADINAS": "VC",
  "ILHAS VIRGENS BRITANICAS": "VG",
  "ILHAS VIRGENS AMERICANAS": "VI",
  "VIETNA": "VN",
  "IEMEN": "YE",
  "AFRICA DO SUL": "ZA",
  "ENGLAND": "GB",
  "REPUBLIQUE DE GUINEE": "GN",
  "IVORY COAST": "CI",
  "REPUBLIC OF KOREA": "KR",
  "DEMOCRATIC PEOPLES REPUBLIC OF KOREA": "KP",
  "DEMOCRATIC REPUBLIC OF CONGO": "CD",
  "DEMOCRATIC REPUBLIC OF THE CONGO": "CD",
  "REPUBBLICA DEMOCRATICA DEL CONGO": "CD",
  "REPUBLIQUE DEMOCRATIQUE DU CONGO": "CD",
  "DR CONGO": "CD",
  "DRC": "CD"
};
